import EditSectionPage from "./EditSectionPage";

import { editAircraftInformationExtendedSchema } from "../../forms/privateAviation/user/formSchema";
import AircraftInformationExtended from "../../forms/privateAviation/user/steps/AircraftInformationExtended";

const OperationsEditPage = () => {
  return (
    <EditSectionPage
      title="Operations & Trips"
      schema={editAircraftInformationExtendedSchema}
      step={3}
    >
      <AircraftInformationExtended />
    </EditSectionPage>
  );
};

export default OperationsEditPage;
